import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { Translate } from 'react-redux-i18n'
import { Checkbox } from '../html/checkbox'
import { Element } from '../html/element'
import classes from './index.module.scss'

const ItemCheckAll = ({
  titleCheckboxAll,
  allId,
  listChecked,
  setListChecked,
}) => {
  const [isChecked, setIsCheck] = useState(false)

  useEffect(() => {
    if (allId.length > 0 && allId.every((id) => listChecked.includes(id))) {
      setIsCheck(true)
    } else {
      setIsCheck(false)
    }
  }, [listChecked, allId])

  const handleChangeCheckbox = (checked) => {
    if (checked) setListChecked(allId)
    else setListChecked([])
  }

  const onRowClick = () => {
    const condition = listChecked.length && listChecked.length === allId.length
    if (!condition) setListChecked(allId)
    else setListChecked([])
  }

  return (
    <Element elementName="li" className={classes.li} onClick={onRowClick}>
      <Element className="dFlex alignItemsCenter">
        <Element elementName="label" className={classes.labelCheckbox}>
          <Checkbox onChange={handleChangeCheckbox} checked={isChecked} />
        </Element>
        <Element>
          <Translate value={titleCheckboxAll} />
          &nbsp;
        </Element>
      </Element>
    </Element>
  )
}

ItemCheckAll.propTypes = {
  titleCheckboxAll: PropTypes.string.isRequired,
  allId: PropTypes.array.isRequired,
  listChecked: PropTypes.array.isRequired,
  setListChecked: PropTypes.func.isRequired,
}

export default ItemCheckAll
